import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import axios from 'axios';
import { url } from '../../weburl';
import CountryContext from '../country_context';
import { BeatLoader, SyncLoader } from 'react-spinners';
import Swal from 'sweetalert2';
export const RegisterModal = (props) => {

    const context = useContext(CountryContext)
    const [phoneNumber, setPhoneNumber] = useState()
    const [modalResponse, setModalResponse] = useState()
    const [open, setOpen] = useState(props.open)
    const handleClose = () => {

    }

    return (

        <div className='brand-yellow-border'>
            <Dialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >

                <DialogContent dividers style={{ backgroundColor: "#28261f" }}>
                    {props.submittedModal ?
                        <BeatLoader />
                        :
                        <div className="container-fluid py-2  ">

                            <div className="row align-items-center justify-content-center">
                                <div className="col-md-12  py-2 text-left
                                ">

                                    <SyncLoader color='#ba8108'/>
                                    
                                    <h4 className='text-white mt-3'>Getting ready!!! </h4>
                                    <h6 className='text-white mb-5'>Please login/signup if you are not</h6>
                                    <div className='text-left'>
                                        <div className='mb-2'><Link to='/login' className="text-warning"> Login</Link> </div>
                                        <div ><Link to='/signup' className="text-warning"> Signup</Link> </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                </DialogContent>

            </Dialog>

        </div >

    )
}